import React from "react";

// import LandingPageHeader from "components/Headers";
import Footer from "components/Footers";
import PublicNavbar from "components/PublicNavbar";
import PopUpTerm from "components/PopUpTerm";
import routes, { renderRoutes } from "routes";
import "assets/css/public.css";
import "assets/css/cookie-consent.css";
import CookieConsent from "components/CookieConsent";

const PublicLayout = (props) =>{

    return (
          <>
            <PublicNavbar />

            <div className="filter" />
            {renderRoutes(routes)}
            <Footer fluid />
            <CookieConsent />
            <PopUpTerm />
          </>
      );
};

export default PublicLayout;